window.addEventListener("load", (event) => {
  let accordions = document.querySelectorAll(".footer_menu_accordion");

  accordions?.forEach((accordion)=>{
    let accordionItems = accordion.querySelectorAll(".accordion_item");

    accordionItems?.forEach((accordionItem) => {
      let btn = accordionItem.querySelector(".accordion_button");
  
      if (accordionItem.classList.contains("active")) {
        show(accordionItem);
      } else {
        hide(accordionItem);
      }
  
      btn.addEventListener("click", () => {
        collapsOthers(accordionItems, accordionItem);
  
        if (accordionItem.classList.contains("active")) {
          accordionItem.classList.remove("active");
          hide(accordionItem);
        } else {
          accordionItem.classList.add("active");
          show(accordionItem);
        }
      });
    });
  })
});

function show(accordion) {
  accordion.querySelector(".accordion_content").style.height =
    accordion.querySelector(".accordion_content .content_wrapper")
      .offsetHeight + "px";
}

function hide(accordion) {
  accordion.querySelector(".accordion_content").style.height = 0 + "px";
}

function collapsOthers(accordionItems, crntItem) {
  accordionItems.forEach((accordionItem) => {
    if (accordionItem !== crntItem) {
      accordionItem.classList.remove("active");
      hide(accordionItem);
    }
  });
}
